export const DEFAULT_PAGE_TITLE = '1Mentor';
